import { render, staticRenderFns } from "./LargeButton.vue?vue&type=template&id=7f8979f2&scoped=true&"
import script from "./LargeButton.vue?vue&type=script&lang=js&"
export * from "./LargeButton.vue?vue&type=script&lang=js&"
import style0 from "./LargeButton.vue?vue&type=style&index=0&id=7f8979f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8979f2",
  null
  
)

export default component.exports